import * as React from 'react';
import { Box, Heading } from '@chakra-ui/react';

interface IProps {
  id?: string;
  title: string | React.ReactNode;
  children?: React.ReactNode;
  uploadWarning?: boolean;
}

const RequirementsSummary = (props: IProps) => {
  const { children, id, title, uploadWarning } = props;

  return (
    <Box
      data-selector={id}
      my={4}
      bgColor="chakra-subtle-bg"
      borderLeftWidth={8}
      borderLeftColor={uploadWarning ? 'orange.400' : 'chakra-border-color'}
      borderRadius="lg"
      px={{ base: 3, lg: 4 }}
      py={{ base: 3, lg: 4 }}
    >
      <Heading as="h4" fontSize="lg" mb={2}>
        {title}
      </Heading>

      <Box>{children}</Box>
    </Box>
  );
};

export { RequirementsSummary };
